module.exports = __webpack_public_path__ + "img/error.ef9f6bf7.svg";